// extracted by mini-css-extract-plugin
module.exports = {"shape1":"about-module--shape1--1Tp3O","shape2":"about-module--shape2--3Ooh_","shape3":"about-module--shape3--yYnnR","shape4":"about-module--shape4--3USvn"};